"use strict";
(function BasePluginDefinition(global) {

  /** 
  * Базовый класс-плагин
  * @class WebAccess.Plugin    
  * @property {String} name имя плагина
  * @property {String} className имя класса
  * @since 5.2.0.1100
  */
  global.Plugin = BaseObject.extend({
    __isPlugin: true,
    name: null,    
    className: 'Plugin',
    
    init: function (params) {
      this._super(params);      
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Метод регистрации плагина, этот метод вызывается автоматически.
    * В него передается ссылка на расширяемый объект.
    * @param {object} context - расширяемый объект
    * @method WebAccess.Plugin.register
    * @since 5.2.0.1100
    * @return {object} свойства и методы которые будут доступны в расшияремом классе    
    * @example
    *  //Принцип работы с плагинами
    *  var SomeClass = BaseObject.extend([WebAccess.mixins.pluginMixin],{
    *    init: functtion() {
    *      this._super();
    *    }
    *  });
    *  ....
    *  var SomePlugin = WebAccess.Plugin.extend({
    *    name: 'somePlugin',
    *    init: functtion() {
    *      this._super();
    *    },
    *    register: function() {
    *      return {
    *        'doSomething': this.doSomething_exported
    *      }
    *    }
    *    doSomething_exported: function() {
    *      return
    *    }
    *  });    
    *  ...
    *  var instance = new SomeClass(param1, param2, ..., paramN, {plugins: [new SomePlugin()] });
    */
    register: function (context) {
      this.bind('classInit', this.afterClassInit);
      return {}
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Метод, который будет вызван после инициализации расширяемого объекта.    
    * @param {object} context - расширяемый объект
    * @method WebAccess.Plugin.afterMainClassInit
    * @since 5.2.0.1100
    * @return {object} свойства и методы которые будут доступны в расшияремом классе
    */
    afterMainClassInit: function(context) {
      return;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      
  });

})(window.WebAccess);